export default __webpack_public_path__ + "aaec91d935b781e37108873c9de17d3f.png";